import { Directive, Input, ElementRef } from '@angular/core';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import {
	SystemCapabilityEnum,
	SystemCapabilityName,
} from 'src/app/models/data/systemCapability';

type UnauthorizedAction = 'hide' | 'show';
@Directive({ selector: '[appHasSystemCapability]' })
export class HasSystemCapabilityDirective {
	@Input() appHasSystemCapability = undefined;

	unauthAction: UnauthorizedAction = 'hide';
	authorized = false;

	constructor(
		private element: ElementRef,
		private systemCapabilityService: SystemCapabilityService
	) {}

	private setAuthorized(): void {
		const authorized = this.authorized;
		if (authorized) {
			this.updateAuthorized();
		} else {
			this.updateUnauthorized();
		}
	}

	private resetAuthorizeDisplay(): void {
		this.element.nativeElement.style.display = null;
		this.element.nativeElement.disabled = false;
	}

	private updateAuthorized(): void {
		switch (this.unauthAction) {
			case 'hide':
				this.element.nativeElement.style.display = null;
				break;
			case 'show':
				this.element.nativeElement.style.display = 'none';
				break;
		}
	}

	private updateUnauthorized(): void {
		this.resetAuthorizeDisplay();
		switch (this.unauthAction) {
			case 'hide':
				this.element.nativeElement.style.display = 'none';
				break;
			case 'show':
				this.element.nativeElement.style.display = null;
				break;
		}
	}

	@Input() set has(
		systemCapability: SystemCapabilityEnum | SystemCapabilityName | undefined
	) {
		if (!systemCapability) {
			return;
		}
		this.authorized = this.systemCapabilityService.has(systemCapability);
		this.setAuthorized();
	}

	@Input() set hasOne(
		systemCapabilities:
			(SystemCapabilityEnum | SystemCapabilityName)[] | undefined
	) {
		if (!systemCapabilities) {
			return;
		}
		this.authorized = this.systemCapabilityService.hasOne(systemCapabilities);
		this.setAuthorized();
	}

	@Input() set hasAll(
		systemCapabilities:
			(SystemCapabilityEnum | SystemCapabilityName)[] | undefined
	) {
		if (!systemCapabilities) {
			return;
		}
		this.authorized = this.systemCapabilityService.hasAll(systemCapabilities);
		this.setAuthorized();
	}

	@Input() set unauthorizedAction(action: UnauthorizedAction) {
		this.unauthAction = action;
		this.setAuthorized();
	}
}
